/* まんがギャラリー(本文中の横スクロール)のページ送り。2026-08-29 新設。
 *
 * 本文が出すのはマークアップだけ(公開時のサニタイザが script を必ず落とすため、
 * 挙動はテーマが与える)。契約:
 *   .tr-manga-pager               … スクロールスナップの入れ物
 *   .tr-manga-pager > .gp-manga__page … 1ページ(中に img。拡大表示は gp-manga-lightbox.js)
 *
 * ここで足すもの:
 *   ・左右の矢印ボタン(PC/SP 共通。端では disabled にする=消すと次のクリックが
 *     暗幕に落ちるため、gp-manga-lightbox.js と同じ方針)
 *   ・ページ位置ドット(ネイティブのスクロールバーはCSSで消した=バーのドラッグが
 *     スナップと喧嘩して挙動が悪い、の2026-08-29 ユーザー指示)。押すとそのページへ移動
 *   ・ページが替わるたび表示URLに ?img=N(GA4 拡張計測が履歴イベントで page_view を
 *     数える=アクセス計測。replaceState のみ・1ページ目では消す・canonical は不変)
 *     ★拡大表示(gp-manga-lightbox.js)が開いている間は URL をあちらが管理するので触らない。
 *
 * ★PC のマウスドラッグ送りは**廃止**(2026-08-29 ユーザー指示。PC のギャラリー操作は
 *   「左右の矢印+クリックで拡大」だけに絞る)。SP は従来どおりネイティブの
 *   スワイプ(スクロールスナップ)に任せる=ここでは何も足さない。
 *
 * ── 2026-09-03 の拡張(Geminiパスポート面のカルーセル化)────────────────
 * 1) **複数インスタンス対応**。旧版は 1 記事 1 ギャラリー前提(document.querySelector)
 *    だったが、まんが面は無限スクロールで話が積み上がるため器が複数になる。
 *    初期化本体を initPager(pager) に閉じ込め、状態は全てそのクロージャに持つ。
 *    trends 面(器が1個)の挙動は従来と同一。
 * 2) **読み方向は器の CSS(direction)が決める**。trends 面は LTR、まんが面は
 *    **RTL**(次のページが左。2026-09-04 ユーザー指示で、拡大表示の「‹ が次」と
 *    向きをそろえた)。座標は符号つきで扱い、clamp も向きで反転する。
 *    ★RTL では**ネイティブの smooth スクロールが使えない**(Chrome 148 実測:
 *      RTL のスクロールコンテナに対する scrollTo/scrollBy の behavior:"smooth" は
 *      負の left を無視して何も起きない。instant と scrollLeft 代入だけが効く)。
 *      そのため送りは **requestAnimationFrame の自前アニメーション**で行う
 *      (scrollLeft への代入は両方向で正しく動く)。両面で同じ経路を通すことで、
 *      向きによる挙動差を作らない。
 * 3) **器の後付け**(data-gpm-carousel が立つ面だけ)。まんが面の本文は公開済みで、
 *    素の <figure class="gp-manga__page"> が縦に並んでいる。記事を作り直さずに
 *    横送りへ変えるため、連続する figure を器にまとめるのはここで行う。
 *    JS が動かない環境では従来どおり縦に並ぶ(何も壊れない)。
 */
(function () {
  "use strict";
  var URL_PARAM = "img";
  /* 拡大表示は面ごとに1つ(セクションが持つ)。URL の所有権の判定に使う。 */
  var lightbox = document.querySelector("[data-gpm-lightbox]");

  /* ── 器の後付け(まんが面だけ)────────────────────────────────
     ★opt-in を属性にする理由: trends 面の記事ルートにも data-gp-manga-article が
       付いている(共有ライトボックスを使うため)。ルートの有無で判定すると
       trends 面まで巻き込むので、まんが面のセクションだけが立てる印で切る。 */
  var CAROUSEL_ROOT = "[data-gpm-carousel]";

  /* 先読み隠し(html.gpm-js)の管理者。実体は gp-manga-assets.liquid の同期スクリプト。
     trends 面にはそもそも存在しない(先読み隠しも無い)ので、その場合は素通しする。 */
  var prehide = window.gpmPrehide;
  function releasePrehide() {
    if (prehide) prehide.release();
    document.documentElement.classList.remove("gpm-js");
  }

  /* 連続する figure.gp-manga__page を1つの器にまとめる。
     ★1枚だけの並びは器を作らない(送るものが無いのに枠と余白だけ増える)。
     ★既に器の中にある figure は触らない(追記のたびに呼ばれるので再入可能にする)。 */
  function buildPagers(scope) {
    var figs = scope.querySelectorAll(".gp-manga figure.gp-manga__page");
    var i = 0;
    while (i < figs.length) {
      var first = figs[i];
      var parent = first.parentElement;
      if (!parent || parent.classList.contains("tr-manga-pager")) { i++; continue; }
      /* 兄弟として続いている figure をひとまとまりにする(間に文章が挟まれば別の器) */
      var group = [first];
      var node = first.nextElementSibling;
      while (node && node.matches && node.matches("figure.gp-manga__page")) {
        group.push(node);
        node = node.nextElementSibling;
      }
      i += group.length;
      if (group.length < 2) continue;
      /* 矢印は器の外(frame)に絶対配置する。frame を position:relative にするのは
         CSS 側(.gpm-gallery)。本文の器(.gp-manga)自体を relative にしない
         — あの中には記事本文が丸ごと入っており、無関係な絶対配置に影響しうる。 */
      var frame = document.createElement("div");
      frame.className = "gpm-gallery";
      var box = document.createElement("div");
      box.className = "tr-manga-pager";
      parent.insertBefore(frame, first);
      frame.appendChild(box);
      for (var k = 0; k < group.length; k++) box.appendChild(group[k]);
      /* ドットの予約枠。CSS の min-height が高さを先取りして CLS を防ぐ。 */
      var dots = document.createElement("div");
      dots.className = "tr-manga-pager__dots";
      frame.appendChild(dots);
    }
  }

  function initPager(pager) {
  if (pager.hasAttribute("data-tr-pager-init")) return;   /* 二重実行ガード */
  pager.setAttribute("data-tr-pager-init", "");
  /* ★スクロールバー非表示(--enhanced)は**最初に**宣言する。最終行で付けると
     classic scrollbar 環境(バーがレイアウト領域を消費する)で初回描画後に
     pager の高さが縮む layout shift になるため、スクリプト実行の先頭で付けて
     描画前に確定させる。初期化が途中で例外死した場合は catch で外し、
     ネイティブのスクロールバーを操作手段として復元する(完全なロールバックではなく
     「最低限の操作手段を残す fail-safe」。部分生成の矢印等は残り得るが害はない)。 */
  pager.classList.add("tr-manga-pager--enhanced");
  try {
  var wrap = pager.parentElement || pager;
  if (getComputedStyle(wrap).position === "static") wrap.style.position = "relative";
  /* 読み方向。CSS の direction が唯一の出どころ(まんが面 = rtl / trends 面 = ltr)。
     RTL では scrollLeft が 0〜負を取る(CSSOM View)ので、座標は符号つきで扱う。 */
  var RTL = getComputedStyle(pager).direction === "rtl";
  function pages() { return pager.querySelectorAll(".gp-manga__page"); }

  /* 各ページのスクロール座標(先頭ページからの実測距離)。
     ★`step() * (N - 1)` にしない(2026-09-03 レビュー指摘)。offsetLeft は
       整数に丸められた long(CSSOM View)なので、1区間ぶんの丸め誤差を
       ページ数だけ乗算してしまう。実測(Chrome・幅390.5px)では step=321 に対し
       11ページ目の実座標 3205 / 式の値 3210 = 5px ずれ、静止ゲート(4px)を越えて
       commit() が永久に early return する(URLもドットも矢印も更新されなくなる)。
       ページごとに実座標を測れば誤差は累積しない。 */
  function offsets() {
    var k = pages();
    if (!k.length) return [0];
    var base = k[0].offsetLeft;
    var list = [];
    for (var i = 0; i < k.length; i++) list.push(k[i].offsetLeft - base);
    return list;
  }
  /* target ページ(1始まり)の座標。スクロール可能範囲へ clamp する
     (最終ページの理論座標が最大スクロール量を超えると到達できず、
      pending が永遠に解けない)。 */
  function coord(target) {
    var o = offsets();
    var x = o[Math.min(o.length, Math.max(1, target)) - 1] || 0;
    /* スクロール可能量は常に正。RTL では座標が 0〜-max を取るので clamp を反転する
       (ここを Math.max(0, …) のままにすると RTL で全ページの目標が 0 になり、
        ページ送りが完全に効かなくなる)。 */
    var max = pager.scrollWidth - pager.clientWidth;
    return RTL ? Math.min(0, Math.max(-max, x)) : Math.max(0, Math.min(max, x));
  }
  /* いま見えているページ = 実座標がいちばん近いページ */
  function current() {
    var o = offsets();
    var x = pager.scrollLeft, best = 1, bestDist = Infinity;
    for (var i = 0; i < o.length; i++) {
      var d = Math.abs(x - o[i]);
      if (d < bestDist) { bestDist = d; best = i + 1; }
    }
    return best;
  }

  /* ★URL を書いてよい器かどうか(複数インスタンス対応で追加・2026-09-03)。
     器が1つだけの面(trends)は常に true = 従来と同じ。
     まんが面は無限スクロールで複数の話が同じ DOM に載るので、
     **いま表示URLが指している話**の器だけが ?img を書く。
     gp-manga.js は現在地の話へ history.replaceState で path を差し替えるので、
     「自分の話の data-url の path == location.pathname」が所有権の判定になる
     (あちらの内部状態に結合しない)。 */
  function ownsUrl() {
    /* trends 面(カルーセル化の印が無い)は従来どおり常に所有者。
       ★件数(allPagers.length <= 1)で分岐してはいけない(2026-09-03 レビュー指摘):
         まんが面でも「複数ページの話A + 1ページだけの話B」なら器は1個のままで、
         Aの遅延 commit が B の URL へ ?img を書いてしまう。判定は器の個数ではなく
         **その器がまんが面に属するか**で決める。 */
    if (!pager.closest(CAROUSEL_ROOT)) return true;
    if (!pager.isConnected) return false;
    var entry = pager.closest("[data-hta-entry]");
    if (!entry) return false;
    /* 1つの話に器が複数できた場合(本文のレイアウトが変わって figure の並びが
       途中で切れたとき)は**先頭の器だけ**を書き手にする。全員が書くと同じ URL の
       ?img を取り合う。現在の build_article.py はページを1本の連続で出すので
       器は話ごとに1つだが、将来の本文変更で静かに壊れないようにここで閉じておく。 */
    if (entry.querySelector(".tr-manga-pager") !== pager) return false;
    var u = entry.getAttribute("data-url");
    if (!u) return false;
    try { return new URL(u, window.location.href).pathname === window.location.pathname; }
    catch (e) { return false; }
  }

  /* ★URL の書き込みはこの1関数だけ。履歴(どの操作が予約したか)ではなく
     **発火時点の状態**で書いてよいかを判定する(レビュー指摘の構造対応):
     状態検証型なので、どの経路から何回呼ばれても正しい結果に収束し、
     旧世代タイマーの誤発火という概念自体が消える。 */
  function commit() {
    if (lightbox && !lightbox.hidden) return;   /* 拡大表示中の URL はあちらの所有 */
    var n = current();
    /* スナップ座標に静止している時だけ書く(smooth 移動の中間位置で
       丸めたページを書かない=GA4 に中間 page_view を混ぜない) */
    if (Math.abs(pager.scrollLeft - coord(n)) > 4) return;
    /* goTo 進行中(pending)は目標到達時だけ完了扱いにする。
       到達を確定したら corrTimer も含めて操作を完了させる(finishPending) */
    if (pending !== null) {
      if (n !== pending) return;
      finishPending();
    }
    updateNav();
    if (suppressedPage !== null) {
      if (n === suppressedPage) return;   /* close 時と同じページ: クリーン URL を維持 */
      suppressedPage = null;              /* 実際にページが変わった=ユーザーの新規操作 */
    }
    if (!ownsUrl()) return;               /* 表示URLが指していない話の器は書かない */
    try {
      var url = new URL(window.location.href);
      if (n <= 1) {
        if (!url.searchParams.has(URL_PARAM)) return;
        url.searchParams.delete(URL_PARAM);
      } else {
        if (url.searchParams.get(URL_PARAM) === String(n)) return;
        url.searchParams.set(URL_PARAM, String(n));
      }
      history.replaceState(history.state, "", url);
    } catch (e) { /* URL API が無い環境では何もしない */ }
  }
  /* commit の予約(150ms debounce)。scroll ハンドラーと goTo の到達済み早期 return の
     両方がここを通る(同期契機の喪失防止・レビュー指摘) */
  function scheduleCommit() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; commit(); }, 150);
  }


  /* OS の「視差効果を減らす」設定では横移動をアニメーションさせない
     (2026-09-03 レビュー指摘。まんが面で新しく全面横移動を導入するため)。
     判定は移動のたびに行う(設定は閲覧中に変わりうる)。 */
  var REDUCE = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
  function animates() { return !(REDUCE && REDUCE.matches); }
  /* スムーススクロール中の連打対策: 矢印の基準は「見えているページ」でなく
     「移動先(pending)」にする。視覚位置基準だと ›› と2連打しても、1回目の
     アニメーション中は current() が動かず 1ページしか進まない。
     pending はスクロールが静止した時(sync)と手動スワイプの開始で捨てる。 */
  var pending = null;
  var goSeq = 0;        /* goTo の世代。補正タイマーが後発の操作を巻き戻さないための番号 */
  var manual = false;   /* 直近にユーザーの手動操作があったか(補正タイマーを無効化) */
  var corrTimer = null; /* 到達保証タイマー(常に最新の goTo のものだけ生かす) */
  var timer = null;     /* URL 同期(commit)の 150ms debounce */
  /* ★close 抑止(レビュー指摘の再設計): ライトボックス close 後は
     「close 時点と同じページに居る限り URL を書かない」。
     ブール(禁止フラグ+入力armで解除)による履歴追跡は、stale scroll・縦ホイール・
     リサイズ再スナップ・キーボードスクロールの組合せで false release / 永久非同期を
     生んだため廃止し、**ページ番号の比較**という状態検証に置き換えた:
     ・stale scroll / 再スナップ / リサイズ → 同じページ → 書かない
     ・ユーザーが実際に別ページへ移動(スワイプ/キーボード) → ページが変わる → 解除
     ・goTo(矢印/ドット)=明示操作 → 即解除 */
  var suppressedPage = null;
  function base() { return pending !== null ? pending : current(); }
  /* 進行中の smooth アニメーションを座標 x で**即時**停止する。
     ★behavior:"auto" は instant の別名ではない(computed scroll-behavior:smooth だと
     smooth になる: CSSOM View)。"instant" が第一選択。enum 非対応の古い実装は
     TypeError になるので catch し、scroll-behavior を一時的に auto へ固定してから
     座標を代入する(scrollLeft 代入も仕様上は behavior:auto のため)。
     ※現 CSS は pager に scroll-behavior:smooth を当てない契約(この保険は将来の
       CSS 変更へのガード)。 */
  function halt(x) {
    stopAnim();
    try { pager.scrollTo({ left: x, behavior: "instant" }); }
    catch (err) {
      var prev = pager.style.scrollBehavior;
      pager.style.scrollBehavior = "auto";
      pager.scrollLeft = x;
      pager.style.scrollBehavior = prev;
    }
  }

  /* ── 送りのアニメーション(自前)────────────────────────────────
     ★ネイティブの `scrollTo({behavior:"smooth"})` は使わない。RTL のスクロール
       コンテナでは負の left を無視して何も起きない(Chrome 148 実測)。
       scrollLeft への代入は両方向で正しく動くので、rAF で自分で補間する。
       LTR 面(trends)も同じ経路を通す=向きによる挙動差を作らない。
     ★動き軽減(prefers-reduced-motion)と rAF 非対応環境では即座に飛ぶ。
     ★非表示タブでは rAF が止まるが、goTo の 600ms 到達保証タイマーが座標を
       直接書くので到達は保証される(従来と同じ安全網)。 */
  var animId = null;
  var animSnap = null;   /* アニメ中に退避した inline の scroll-snap-type */
  var ANIM_MS = 320;
  /* アニメーションを止め、snap を必ず元に戻す(冪等)。 */
  function stopAnim() {
    if (animId !== null) {
      if (typeof cancelAnimationFrame === "function") cancelAnimationFrame(animId);
      animId = null;
    }
    if (animSnap !== null) { pager.style.scrollSnapType = animSnap; animSnap = null; }
  }
  function animateTo(x) {
    stopAnim();
    var from = pager.scrollLeft;
    var dist = x - from;
    if (!animates() || typeof requestAnimationFrame !== "function" || Math.abs(dist) < 1) {
      halt(x);
      return;
    }
    /* ★アニメーション中だけ snap を切る。`scroll-snap-type: x mandatory` のままだと、
       途中の座標を代入するたびに**いちばん近いスナップ点へ引き戻される**
       (実測: -20 / -100 / -160 を代入 → すべて 0 に戻り、-200 で一気に -320)。
       ネイティブの smooth はブラウザ側が snap を承知で動かすので問題にならないが、
       自前で1フレームずつ書くこの経路では必ず外す必要がある。
       戻すのは「到達時」と stopAnim()(手動操作・割り込み・halt)の両方。 */
    animSnap = pager.style.scrollSnapType;
    pager.style.scrollSnapType = "none";
    var t0 = null;
    animId = requestAnimationFrame(function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / ANIM_MS);
      /* easeInOutQuad。等速だと止まり際が固く見える */
      var e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      pager.scrollLeft = from + dist * e;
      if (k < 1) { animId = requestAnimationFrame(step); return; }
      animId = null;
      pager.scrollLeft = x;
      if (animSnap !== null) { pager.style.scrollSnapType = animSnap; animSnap = null; }
    });
  }
  /* ★先行操作の一括失効(レビュー指摘): 「すべての goTo は、それ以前の goTo 世代を
     完了または失効させる」を不変条件にする。早期 return 経路でも必ず通す。
     ★150ms debounce(timer)も**ここで**失効させる(corrTimer だけ消すと、旧世代の
     debounce が新しい pending を読み違えて消す競合が残る・レビュー指摘)。
     散在する失効処理の漏れが R4→R5 の欠陥の直接原因だったため、非同期状態の
     無効化はこの1関数に集約する。 */
  function cancelPending() {
    stopAnim();
    if (corrTimer) { clearTimeout(corrTimer); corrTimer = null; }
    if (timer) { clearTimeout(timer); timer = null; }
    goSeq++;
    pending = null;
  }
  /* ★goTo の完了(目標到達を commit が確定)時の後始末(レビュー指摘):
     pending を消すだけだと、同じ操作を表す 600ms corrTimer クロージャが独立に
     生き残り、直後のキーボード移動等を旧目標へ巻き戻す。到達確定と同時に
     補正も完了扱いにして、操作全体を単一のライフサイクルに揃える。
     (URL debounce はここで消さない=既到達分の同期契機を失わないため) */
  function finishPending() {
    if (corrTimer) { clearTimeout(corrTimer); corrTimer = null; }
    goSeq++;
    pending = null;
  }
  function goTo(target) {
    suppressedPage = null;       /* 明示的な pager 操作 = URL 同期を再開してよい */
    cancelPending();             /* 先行の smooth/補正を世代ごと失効(早期 return 前に必ず) */
    var n = pages().length;
    target = Math.min(n, Math.max(1, target));
    var x = coord(target);
    if (Math.abs(pager.scrollLeft - x) <= 4) {
      /* 既に目標位置(現在ドット再クリック・進行中操作の引き返し):
         先行の smooth アニメーションも**ここで止める**(cancelPending はタイマーを
         失効させるだけで、ブラウザのアニメーション自体は止めないため)。
         ★同一座標への scrollTo は scroll イベントを保証しないので、URL 同期の契機を
         ここで明示的に予約する(直前の debounce を cancelPending が消していても
         同期が失われない・レビュー指摘)。commit は状態検証型なので二重予約も無害。 */
      halt(x);
      updateNav();
      scheduleCommit();
      return;
    }
    pending = target;
    manual = false;
    var seq = ++goSeq;
    animateTo(x);
    /* 到達保証(非表示タブ等では smooth のアニメーションが進まないことがある)。
       ★巻き戻し防止(レビュー指摘):
       ・後発の goTo(seq)/ユーザー操作(manual)/DOM切離しなら何もしない
       ・目標座標は実行時点の実測座標で**再計算**(リサイズ後の古い座標を書かない)
       ・最後に scheduleCommit(URL 書き込みの可否は commit の状態検証が判定するため
         ここから予約しても安全。補正ジャンプの scroll イベント配信に依存しない) */
    if (corrTimer) clearTimeout(corrTimer);
    corrTimer = setTimeout(function () {
      corrTimer = null;
      if (seq !== goSeq || manual || pager.isConnected === false) return;
      /* 非表示タブなどで rAF が一度も動かないと snap を切ったままになる。
         座標を直接書く前に必ず後始末する(stopAnim は冪等)。 */
      stopAnim();
      var x2 = coord(target);
      if (Math.abs(pager.scrollLeft - x2) > 4) pager.scrollLeft = x2;
      scheduleCommit();   /* 補正の有無に関わらず同期契機を保証(commit が状態検証) */
    }, 600);
  }

  function makeNav(dir, label, glyph) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "tr-manga-pager__nav tr-manga-pager__nav--" + (dir > 0 ? "next" : "prev");
    b.setAttribute("aria-label", label);
    b.textContent = glyph;
    b.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();     /* 拡大表示のクリック委譲に拾わせない */
      goTo(base() + dir);
    });
    wrap.appendChild(b);
    return b;
  }

  /* 矢印の字は読み方向にそろえる(RTL 面では「次」が左向き)。位置は CSS が決める。
     ★ボタン自身は CSS で direction:ltr に固定してある(RTL を継承すると
       ‹ と › が双方向アルゴリズムで鏡映されて左右が入れ替わるため)。 */
  var prevBtn = makeNav(-1, "前のページ", RTL ? "›" : "‹");
  var nextBtn = makeNav(1, "次のページ", RTL ? "‹" : "›");

  /* 位置ドット。ページ数は本文で確定している(あとから増えない)ので一度だけ作る。 */
  var dots = [];
  /* 本文側に予約枠 <div class="tr-manga-pager__dots"></div> があればそれを使う
     (CSS の min-height で領域を先取りし、後挿入による CLS を避ける)。
     無い旧記事では従来どおり生成して挿入する。
     ★探索は **wrap の中だけ**(複数インスタンス対応・2026-09-03)。document 全体を
       見ると2つ目以降の器が1つ目のドット枠を奪う。器が1つの面では結果は同じ。 */
  var dotsBox = wrap.querySelector(".tr-manga-pager__dots") || document.createElement("div");
  dotsBox.className = "tr-manga-pager__dots";
  Array.prototype.forEach.call(pages(), function (_, i) {
    var d = document.createElement("button");
    d.type = "button";
    d.className = "tr-manga-pager__dot";
    d.setAttribute("aria-label", (i + 1) + "ページ目を表示");
    d.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      goTo(i + 1);
    });
    dotsBox.appendChild(d);
    dots.push(d);
  });
  if (dots.length > 1) {
    if (!dotsBox.parentElement) pager.insertAdjacentElement("afterend", dotsBox);
  } else {
    dotsBox.hidden = true;   /* 1枚のみ: 予約枠ごと畳む */
  }

  /* 矢印はコンテナ(タイトル・注記・ドットを含む)でなく**紙面の縦中央**に置く。
     top:50% のままだと注記やドットのぶん下へずれるため、実測で合わせる。 */
  function placeNav() {
    var t = pager.offsetTop + pager.offsetHeight / 2;
    prevBtn.style.top = nextBtn.style.top = t + "px";
  }

  function updateNav() {
    var n = pages().length;
    var cur = current();
    prevBtn.hidden = nextBtn.hidden = n <= 1;
    prevBtn.disabled = cur <= 1;
    nextBtn.disabled = cur >= n;
    for (var i = 0; i < dots.length; i++) {
      if (i === cur - 1) dots[i].setAttribute("aria-current", "true");
      else dots[i].removeAttribute("aria-current");
    }
  }
  updateNav();
  placeNav();
  /* 紙面の高さは画像の遅延ロードで後から変わる(load イベントより後のこともある)。
     ResizeObserver で紙面サイズの変化に常に追従する(未対応環境は resize/load で近似)。 */
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(placeNav);
    ro.observe(pager);
    ro.observe(wrap);   /* 紙面より上(タイトル/注記)の高さ変化でも offsetTop が変わる */
  }
  window.addEventListener("resize", placeNav);
  window.addEventListener("load", placeNav);

  /* ユーザーの手動操作(指スワイプ・トラックパッド・ホイール・キーボード)は
     goTo の補正より優先する。manual フラグ(発火時参照)に加えて corrTimer を
     **即時失効**させ、世代も進める(cancelPending と同じライフサイクル規律。
     旧 corrTimer が生存したままユーザー移動を旧目標へ巻き戻す窓を閉じる・レビュー指摘)。
     close 抑止の解除は commit() のページ比較が担うため、URL 状態には一切触れない
     (=R6 の manualArmed 型 false release は復活しない)。 */
  function markManual() {
    stopAnim();   /* 指・ホイール・キーの操作が始まったら自前の送りは譲る */
    if (corrTimer) { clearTimeout(corrTimer); corrTimer = null; }
    goSeq++;
    pending = null;
    manual = true;
  }
  pager.addEventListener("pointerdown", markManual, { passive: true });
  pager.addEventListener("wheel", markManual, { passive: true });
  /* スクロールコンテナはキーボードでも動く(Chrome 132+ は tabindex 無しでフォーカス可)。
     これは補正(corrTimer)の中断専用。URL 同期は scroll→commit の通常経路が担う */
  pager.addEventListener("keydown", function (e) {
    var k = e.key;
    if (k === "ArrowLeft" || k === "ArrowRight" || k === "Home" || k === "End" ||
        k === "PageUp" || k === "PageDown" || k === " ") markManual();
  });

  pager.addEventListener("scroll", function () {
    /* 書いてよいかの判定はすべて commit()(状態検証)が行うので、ここは予約だけ。
       stale scroll が届いても、commit は「close 時と同じページ」を書かない。 */
    scheduleCommit();
  }, { passive: true });

  /* ★ライトボックスの open/close で pager 側の「進行中の操作」を世代ごと失効させる。
     150ms debounce の sync が「open 前に予約→close 後に発火」して、close が消した
     ?img を書き戻す競合の遮断(レビュー指摘)。共有 JS(gp-manga-lightbox.js)は
     hidden 属性で開閉するので、属性監視なら共有側を改造せずに世代を追える。 */
  if (lightbox && window.MutationObserver) {
    new MutationObserver(function () {
      cancelPending();            /* timer/corrTimer/世代/pending を一括失効 */
      /* 静止先は**最寄りのスナップ座標**(中途座標だと後からスナップ補正が動く) */
      halt(coord(current()));
      /* このページに居る限り URL を書かない(close がクリーンにした URL の維持)。
         open 時にも記録されるが、open 中は commit 冒頭の hidden チェックが先に
         効くため無害で、close 時の値で上書きされる。 */
      suppressedPage = current();
      updateNav();                /* URL は触らない(所有権は開閉した側にある) */
    }).observe(lightbox, { attributes: true, attributeFilter: ["hidden"] });
  }
  } catch (e) {
    /* 初期化に失敗したら操作 UI は不完全。スクロールバーを復元して操作手段を残す */
    pager.classList.remove("tr-manga-pager--enhanced");
    throw e;
  }
  }

  /* ── 起動 ─────────────────────────────────────────────── */
  /* ★器づくりの権利を**先に**取る(2026-09-03 R3/R4 レビュー指摘)。
     期限切れ後に横へ畳むと、今度は大きな遅延レイアウトずれになるので作らない。
     ★`data-gpm-boot` 属性を見るだけでは足りない: メインスレッドが前段の defer に
       占有されて期限を跨ぐと、timer の callback より先にこの JS が実行権を得てしまい、
       印がまだ立っていないので期限後でも作ってしまう(R4 で実測再現済み)。
       claimBuild() は**経過時間の判定と状態遷移を同じ task の中で**行うので、
       timer が割り込む隙が無い。
     ★まんが面では controller を**必須**にする(2026-09-03 R5 レビュー指摘)。
       同期インラインだけが CSP(script-src の nonce/hash 要求)で拒否されると、
       controller が居ないまま先読み隠しも効かず、pager だけが縦→横へ畳んで
       大きな遅延レイアウトずれになる。controller が居ない/壊れているまんが面では
       器を作らない=縦並びのまま(従来の見た目)へ倒す。
       ※本番の CSP は現在 `block-all-mixed-content; frame-ancestors 'none';
         upgrade-insecure-requests` で script-src が無く、インラインは動く(実測)。
         これは将来 script-src が付いたときのための安全側の既定。
     ★trends 面(カルーセル化の印が無い)は controller の有無に関係なく従来どおり。
       器は本文が出しているので、ここで作るものが無い。 */
  var carouselRoot = document.querySelector(CAROUSEL_ROOT);
  var mayBuild = !carouselRoot ||
    (!!prehide && typeof prehide.claimBuild === "function" && prehide.claimBuild());
  if (!mayBuild) carouselRoot = null;

  function scan() {
    /* ★先読み隠しの解除条件(2026-09-03 レビュー指摘の CLS 対策と対で必要):
       CSS は html.gpm-js のとき「器に入る前の 2ページ目以降」を隠して、初回描画の
       高さを1ページぶんに寄せている(縦3ページ→横1ページの巨大なずれを防ぐ)。
       器づくりが例外で落ちるとページが隠れたままになるので、その時は印を外して
       必ず全ページを見せる(器へ移せたぶんは親が変わるので規則が自然に外れる)。 */
    try {
      if (carouselRoot) buildPagers(carouselRoot);
    } catch (e) {
      releasePrehide();
      throw e;
    }
    var found = document.querySelectorAll(".tr-manga-pager");
    for (var i = 0; i < found.length; i++) {
      /* 1つの器の初期化が落ちても他を巻き込まない(fail-safe はその器の中で完結) */
      try { initPager(found[i]); }
      catch (e) { if (window.console) window.console.error("[tr-manga-pager]", e); }
    }
  }
  scan();
  /* 初回の器づくりが済んだら印は用済み。すぐ外す(2026-09-03 R2 レビュー指摘)。
     ここで外しても器の中のページは隠れない(規則は .gp-manga の**直下** figure だけを
     対象にしており、器へ移した時点で外れている)。あとから追記される話は
     完成済み subtree の同期挿入なので、隠す必要がそもそも無い。
     ★assets 側には DOMContentLoaded と期限切れ(watchdog)の保険がある
       (この JS 自体が届かない・止まる場合の道)。 */
  releasePrehide();

  /* 無限スクロールで話が増える面(まんが面)だけ、追記を拾って器を作り直す。
     監視対象は本文の受け皿の直下(gp-manga.js が話を append する場所)。 */
  if (carouselRoot && window.MutationObserver) {
    var main = carouselRoot.querySelector(".gp-manga-article__main") || carouselRoot;
    new MutationObserver(scan).observe(main, { childList: true });
  }
})();
